/**
 * Sprint 4G.FIX-INPUT — ClearableSelect
 *
 * Wrapper su shadcn Select che aggiunge una "X" per azzerare il valore.
 * - placeholder mostrato quando value è null/""/undefined
 * - X visibile solo se has-value, posizionata a SINISTRA del chevron
 * - X usa pointerDown.preventDefault+stopPropagation per NON aprire il dropdown
 *   (stesso fix dei picker di Geo-Data Fase C/D).
 *
 * Props:
 *   value: stringa o "" / null
 *   onChange: (v: string) => void   ("" quando azzerato)
 *   options: array di [key, label] o array di stringhe
 *   placeholder: stringa (default "Seleziona…")
 *   clearable: bool (default true) — se false la X non appare (per menu obbligatori)
 *   swatches: { chiave: "#rrggbb" } facoltativo — quadratino di colore prima dell'etichetta
 */
import React from "react";
import { X } from "lucide-react";
import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from "@/components/ui/select";

export default function ClearableSelect({
  value,
  onChange,
  options,
  placeholder = "Seleziona…",
  clearable = true,
  disabled = false,
  testId,
  className,
  swatches,
}) {
  const has = value !== null && value !== undefined && value !== "";
  const showClear = clearable && has && !disabled;

  const items = (options || []).map((opt) =>
    Array.isArray(opt) ? opt : [opt, opt]
  );

  return (
    <div className="relative">
      <Select
        value={value || ""}
        onValueChange={(v) => onChange(v)}
        disabled={disabled}
      >
        <SelectTrigger
          className={`${showClear ? "pr-12" : ""} ${className || ""}`.trim()}
          data-testid={testId}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {items.map(([k, label]) => (
            <SelectItem key={k} value={k}>
              {swatches?.[k] && (
                <span className="inline-block h-2.5 w-2.5 rounded-[2px] border border-slate-400 mr-1.5 align-[-1px]"
                      style={{ background: swatches[k] }} data-testid={testId ? `${testId}-swatch-${k}` : undefined} />
              )}
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {showClear && (
        <button
          type="button"
          onPointerDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onChange("");
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          className="absolute right-7 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-slate-200 text-slate-500 hover:text-slate-700 z-10"
          aria-label="Azzera selezione"
          data-testid={testId ? `${testId}-clear` : undefined}
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </div>
  );
}
